import ViewOsobyList from "../../components/views/osoby/ViewOsobyList.jsx";
import ViewTagiList from "../../components/views/tagi/ViewTagiList.jsx";

export const osobyRoutes = [

    {
        path: '/oper/osoby/lista',
        exact: true,
        roles: ['uzytkownicy_podglad'],
        forbidden: true,
        view: <ViewOsobyList/>,
        mode: 'all'
    },
    {
        path: '/oper/tagi/lista',
        exact: true,
        roles: ['pass'],
        forbidden: true,
        view: <ViewTagiList/>,
        mode: 'pass'
    }

]